import { EXTERNAL_WEB_ACTION, RESET_ACTION } from '../staticData';

export function externalWebReducer(state: any, action: any) {
  switch (action.type) {
    case EXTERNAL_WEB_ACTION.set:
      return action.payload;

    case RESET_ACTION:
      return null;

    default:
      throw new Error();
  }
}
